import { pluralizeWithCount } from "@common/helpers/string";
import type { Task } from "@common/types/task";

/** The blocked tag's field, read before its blocker. */
export const BLOCKED_BY_FIELD = "Blocked by";

/** How many open tasks block a task, and the one when it's the only one. */
export type TaskBlockers = Pick<
    Task,
    "numberOfActiveBlockedByTasks" | "soleActiveBlockedByTask"
>;

/** `Blocked by <title>` for the only open blocker, else `Blocked by 3 tasks`. */
export const getBlockedByLabel = ({
    numberOfActiveBlockedByTasks: count = 0,
    soleActiveBlockedByTask,
}: TaskBlockers) =>
    `${BLOCKED_BY_FIELD} ${
        count === 1 && soleActiveBlockedByTask
            ? soleActiveBlockedByTask.title
            : pluralizeWithCount("task", count)
    }`;
